import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-details"},[_c('div',{staticClass:"detail-section__header contact-details__header"},[_vm._v(" Aktualne blokady klienta ")]),_c(VDivider),_c(VDataTable,{staticClass:"details-table",attrs:{"hide-default-footer":"","headers":_vm.headers,"items":_vm.blockages,"items-per-page":-1},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('TableRow',{staticClass:"details-table-row",attrs:{"table-name":"clients","item":item,"header":_vm.headers}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }